/**
 * Admin Reviews Management Page
 * Dedicated page for moderating flagged reviews
 */

import React from 'react';
import {
  Container,
  Box,
  Typography,
  Breadcrumbs,
  Link
} from '@mui/material';
import { NavigateNext, Flag } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import ReviewModerationDashboard from '../components/admin/ReviewModerationDashboard';

const AdminReviewsPage = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      {/* Breadcrumbs */}
      <Breadcrumbs 
        separator={<NavigateNext fontSize="small" />} 
        sx={{ mb: 2 }}
      >
        <Link
          underline="hover"
          sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
          color="inherit"
          onClick={() => navigate('/admin')}
        >
          Admin Dashboard
        </Link>
        <Typography
          sx={{ display: 'flex', alignItems: 'center' }}
          color="text.primary"
        >
          <Flag sx={{ mr: 0.5 }} fontSize="inherit" />
          Review Moderation
        </Typography>
      </Breadcrumbs>

      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" sx={{ fontWeight: 600, mb: 1 }}>
          Review Moderation Dashboard
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Manage and moderate flagged reviews across the platform
        </Typography>
      </Box>

      {/* Dashboard */}
      <ReviewModerationDashboard />
    </Container>
  );
};

export default AdminReviewsPage;



